import { Api } from "api";

export const getBudgetType = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_budget_type/?hash_pw=${hash}`);
  return res.data;
};

export const addBudgetType = async (budget_type: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/add_budget_type/?hash_pw=${hash}&budget_type=${budget_type}`);
  return res.data;
};

export const deleteBudgetType = async (budget_type_id: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/delete_budget_type/?hash_pw=${hash}&budget_type_id=${budget_type_id}`);
  return res.data;
};
